<template>
  <div class="main-body">
    <div class="header">语音报警器</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini" placeholder="请输入Imei号" v-model="imei" clearable style="margin-right:10px;width:160px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"
                :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="imei" label="设备Imei号" width="150"></el-table-column>
        <el-table-column prop="iccid" label="物联网卡iccid号" width="200"></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="mini"  @click="showSetICCID(scope.$index, scope.row)" >设置ICCID</el-button>
            <el-button type="text" size="mini"  @click="showSet(scope.$index, scope.row)" >设置白名单</el-button>
            <el-button type="text" size="mini" @click="Delete(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>
    <Set ref="mySet" v-show="setShow" v-on:closeSet="closeSet"></Set>
    <SetICCID ref="mySetICCID" v-show="setICCIDShow" v-on:closeSet="setICCIDShow=false" v-on:getList="getList"></SetICCID>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";
import {getGovernmentCode} from "@/utils/auth";

import Add from "./AddDisable"
import Set from "./Set"
import SetICCID from "./SetICCID"
import Elderly from "@/views/Elderly/Comm/ElderlyGovClass";


export default {
  name: "Role",
  data() {
    return {

      showModalAdd:false,
      tableLoading:false,

      setShow:false,
      showModalGetElderly:false,
      setICCIDShow:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imei: "",


    };
  },
  components: {Add,Elderly,Set,SetICCID},
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },

    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },



    showSet(index,row){
      this.$refs.mySet.init(row.deviceOWonCatCode);
      this.setShow =!this.setShow;
    },
    closeSet(){
      this.setShow =!this.setShow;
    },
    showSetICCID(index,row){
      this.$refs.mySetICCID.init(row.deviceOWonCatCode,row.iccid);
      this.setICCIDShow =!this.setICCIDShow;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceOWonCat/GovPageClassName",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          imei: this.imei,
          userCode: this.userCode,
          elderlyClassName:'残疾人',

        },
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    Delete(row) {
      this.$confirm("您确定要解绑设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {


        let dataForm = {
          timeStr: timeStr,
          sign: '',
          deviceOWonCatCode: row.deviceOWonCatCode,
        };

        dataForm.sign = "";
        dataForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(dataForm) + "&key="+this.$signKey)


        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceOWonCat/Delete",
          data:dataForm,
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            //this.$message({message: "解绑成功", type: "success",});
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },



  },
};
</script>

<style scoped>
</style>
